import {CreateFile} from "@/libs/Api/Media";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import Helper from "@/libs/Helper";

export default class UploadAdapter {
    constructor(loader,type) {
        // The file loader instance to use during the upload.
        this.loader = loader;
        this.type = type;
    }

    async sendCreateFileRequest(file,type) {
        let result = '';
        let data = {
            base64: null,
            objectId: 0,
            type: 10, // 10 is for library
            priority: null,
        }
        data.base64 = file;
        try {
            let _this = this;
            let createFile = new CreateFile(_this);
            createFile.setRequestParamDataObj(data);
            await createFile.fetch((response) => {
                if (response.isSuccess) {
                    result = response.data.imageName
                }
            });
        } catch (error) {
            console.error(error);
        }
        return result;
    }

    // Starts the upload process.
    async upload() {
        return new Promise((resolve, reject) => {
            const reader = new window.FileReader();
            reader.addEventListener("load", async () => {
                let pictureUrl = await this.sendCreateFileRequest(reader.result.split(",")[1])
                let result = Helper.baseUrl + pictureUrl
                resolve({default: result});
            });
            reader.addEventListener("error", (err) => {
                reject(err);
            });
            reader.addEventListener("abort", () => {
                reject();
            });
            this.loader.file.then((file) => {
                reader.readAsDataURL(file);
            });
        });
    }

    // Aborts the upload process.
    abort() {
        //
    }
}
